module.exports = __webpack_public_path__ + "static/Schokolade-48d9828e92f08b1926eb365aadfffba5.png";